import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener, Input, NgZone } from '@angular/core';
import { finalize, delay } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { untilDestroyed } from 'src/app/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AnalyticsService } from './analytics.service';
import { Main } from 'src/app/core/main.service';
import * as FusionCharts from 'fusioncharts';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PreferencesComponent implements OnInit, OnDestroy {
  title: string;
  ekubTypes: any = [];
  pieConfig: any;
  pieDataSource: any;

  constructor(private router: Router, private route: ActivatedRoute,
    private api: AnalyticsService, private mainService: Main) {

    this.pieDataSource = {
      chart: {
        "caption": "Preference Analysis",
        //"plottooltext": "<b>$percentValue</b> of ekubs $label servers",
        "showLegend": "1",
        "showPercentValues": "1",
        "legendPosition": "bottom",
        "useDataPlotColorForLabels": "1",
        "enablemultislicing": "0",
        "showlegend": "0",
        "theme": "fusion",
        "canvasPadding": "0",
        "chartLeftMargin": "-70",
        width: '100%',
        height: '585',
      },
      data: []
    };

    this.pieConfig = {
      type: 'doughnut3d',
      width: '650',
      height: '500',
      ///palettecolors: "FFE4B5",
      //palettecolors: "#AB6B51 #FFE4B5"
    };
  }

  ngOnInit() {
    this.getStats();
    for (let type of this.ekubTypes) {
      var color;
      if (type.total_members < 1000) {
        color = "#DC143C";
      } else if (type.total_members >= 1000 && type.total_members < 10000) {
        color = "#FFA701";
      } else {
        color =
          "#AB6B51";
      }
      this.pieDataSource.data.push({
        "label": type.name,
        "value": type.total_members,
        "color": color
      });
    }
  }

  getStats() {
    this.ekubTypes = [
      { name: 'daily', total_members: 312 },
      { name: 'weekly', total_members: 34912 },
      { name: 'monthly', total_members: 9992 },
    ];
  }

  loadPreferences() {
    debugger;

  }

  calculateValue() {

  }

  ngOnDestroy(): void {

  }

}
